import $ from 'jquery';
import 'webpack-jquery-ui';
import 'jquery-ui-touch-punch';
import {draggableInput, draggableInputFocus} from './rangeSlider';
import {listen, compose, v$} from './helpers';

export const creditsCalculator = (data, sumInp, termInp, outPut) => {
  const listenInputs = [sumInp, termInp];

  const hasError = (status, element) =>
    status === true
      ? element.parentNode.classList.add('has-error')
      : element.parentNode.classList.remove('has-error');
  const getInpValues = () => {
    return {
      sum: parseInt(sumInp.value),
      term: parseInt(termInp.value)
    };
  };
  const getDayRange = inpVal => {
    const dayRange = Object.keys(data).filter(item => {
      const fromToArr = item.split('-'),
        from = parseInt(fromToArr[0]),
        to = parseInt(fromToArr[1]);
      return from <= inpVal.term && inpVal.term <= to;
    })[0];
    return {
      dayRange,
      sum: inpVal.sum
    };
  };
  const getSumRange = ({ dayRange, sum }) => {
    if (dayRange) {
      const sumRange = Object.keys(data[dayRange]).filter(item => {
        const fromToArr = item.split('-'),
          from = parseInt(fromToArr[0]),
          to = parseInt(fromToArr[1]);
        return from <= sum && sum <= to;
      })[0];
      hasError(false, termInp);
      return {
        dayRange,
        sumRange
      };
    }
    return false;
  };
  const getPercent = ({ dayRange, sumRange }) => {
    if (dayRange && sumRange) {
      hasError(false, sumInp);
      return data[dayRange][sumRange];
    }
    hasError(true, dayRange ? sumInp : termInp);
    return false;
  };
  const outputResult = percent => {
    const inpValues = getInpValues(),
      ouptutSum = inpValues.sum * inpValues.term * percent / 100;
    if (!!percent) {
      outPut.textContent = ouptutSum.toFixed(2);
    }
  };
  const calcRes = compose(
    outputResult,
    getPercent,
    getSumRange,
    getDayRange,
    getInpValues
  );
  // calcRes();
  listen(listenInputs, 'input', e => {
    calcRes();
  });
  listen(listenInputs, 'change', e => {
    calcRes();
  });
  draggableInput(null, calcRes, null, 0);
  draggableInputFocus();

  let creditsInput = v$('.js-credits_sum');

  creditsInput.forEach( (item)=> {
    item.addEventListener('keydown',(e) => {
      const reg = /^\d+$/;
      if( (!reg.test(e.key)) && [',', '.'].includes(e.key)){
        e.preventDefault();
      }
    });
    item.addEventListener('paste',(e) => {
      e.preventDefault();
    });
  });

};
